<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 70vw">
      <div class="modal-header">
        <h5 class="modal-title">Lab Result Details</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body" v-if="resultData">
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Result Status:</label>
          <div class="col-sm-10">
            <p>
              <strong>{{ resultData.result }}</strong>
            </p>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Result Notes:</label>
          <div class="col-sm-10">
            <pre
              style="background: #f5f5f5; padding: 10px; border-radius: 5px"
              >{{ resultData.note }}</pre
            >
          </div>
        </div>

        <div class="form-group row" v-if="resultData.file">
          <label class="col-sm-2 col-form-label">Attachment:</label>
          <div class="col-sm-10">
            <a :href="fileUrl" target="_blank" class="btn btn-sm btn-success"
              >View / Download File</a
            >
          </div>
        </div>
      </div>

      <div class="modal-body" v-else>
        <p>Loading result...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "@/api/apiIndex.js";

export default {
  name: "ViewLabResultModal",
  props: {
    service_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      resultData: null,
    };
  },
  computed: {
    fileUrl() {
      return this.resultData.file
        ? process.env.VUE_APP_BASE_URL + "/" + this.resultData.file
        : null;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-view-result-modal");
    },
    async fetchResult() {
      const url = `services/get_results_by_id/${this.service_id}`;
      try {
        const response = await generalApiRequest(url, "GET", {}, 1);
        if (response.status === "success") {
          this.resultData = response.data;
        }
      } catch (error) {
        console.error("Failed to load result:", error);
      }
    },
  },
  mounted() {
    this.fetchResult();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
